module.exports = __webpack_public_path__ + "img/upload_injury.0cbbc8fc.svg";